import service from '../Common'
import constants from '../../../settings/shared/constants'

function getAllVMType() {
   let jwtToken = localStorage.getItem('accessToken');
   let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
       return service({
           url: constants.api.virtualmachine.getAllVMType,
           method: 'GET',
           headers: headers,
           data:  ''
       }); 
}

function getVMTypes() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.virtualmachine.getVMTypeList,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

function postVMType(VMTypeData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.virtualmachine.postVMType,
            method: 'POST',
            headers: headers,
            data:  VMTypeData
        }); 
 }

 function updateVMType(upateData,id) {
   let jwtToken = localStorage.getItem('accessToken');
   let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
       return service({
           url: constants.api.virtualmachine.updateVMType+id,
           method: 'PUT',
           headers: headers,
           data:  upateData
       }); 
}

function deleteVMType(id) {
   let jwtToken = localStorage.getItem('accessToken');
   let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
       return service({
           url: constants.api.virtualmachine.deleteVMType+id,
           method: 'DELETE',
           headers: headers,
           data:  ''
       }); 
}

function getVMProvisioners() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.virtualmachine.getVMProvisioners,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

function updateMachineTypeStatus(updateStatus,id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.virtualmachine.updateVMTypeStatus+id+'/'+updateStatus,
            method: 'PUT',
            headers: headers,
            data:  ''
        }); 
 }
//To export authentication function
const VirtualMachineTypeService = {
   getAllVMType,postVMType,updateVMType,deleteVMType,getVMProvisioners,getVMTypes,updateMachineTypeStatus
}

export default VirtualMachineTypeService;
